<template>
  <div v-if="user" class="my-profile">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>{{ userName }}</h1>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  mounted() {
    this.$api
      .get('/users/active')
      .then((response) => (this.user = response.data))
  },
  computed: {
    userName() {
      return this.user.firstname + ' ' + this.user.lastname
    },
  },
  data: () => ({
    user: null,
  }),
}
</script>
